export const statusesItemsValues = [
  'cant-schedule',
  'futile',
  'delayed',
  'split-to-base',
  'unallocated',
  'req4change',
] as const;

export const ticketsStatusItemsValues = [
  'new',
  'open',
  'pending_reminder',
  'closed',
  'merged',
  'removed',
  'pending_close',
  'awaiting_dims',
  'awaiting_customer',
] as const;

export type StatusesItemsValue = (typeof statusesItemsValues)[number];
// export type StatusesItemsValue =
//   | 'cant-schedule'
//   | 'futile'
//   | 'delayed'
//   | 'split-to-base'
//   | 'unallocated'
//   | 'req4change'

export type TicketsStatusItemsValue = (typeof ticketsStatusItemsValues)[number];

export interface FieldItems {
  value: StatusesItemsValue;
  title: string;
  props: {
    subtitle?: string;
    titleIcon: string;
  };
}

export interface TicketsStatusItems {
  title: string;
  value: TicketsStatusItemsValue;
}

export const statusesItems: readonly FieldItems[] = [
  {
    value: 'cant-schedule',
    title: 'Can’t be scheduled',
    props: {
      titleIcon: 'mdi-calendar-remove',
    },
  },
  {
    value: 'futile',
    title: 'Futile',
    props: {
      titleIcon: 'mdi-account-alert',
    },
  },
  {
    value: 'delayed',
    title: 'Delayed',
    props: {
      titleIcon: 'mdi-clock-alert',
    },
  },
  {
    value: 'split-to-base',
    title: 'Split to base',
    props: {
      titleIcon: 'mdi-call-split',
    },
  },
];

export const attributesItems: readonly FieldItems[] = [
  {
    // TODO
    // @ts-expect-error
    value: 'DIFF',
    title: 'DIFF',
    props: {
      subtitle: 'Difficult job',
      titleIcon: 'mdi-school',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'FLR',
    title: 'FLR',
    props: {
      subtitle: 'Extra Items to Load',
      titleIcon: 'mdi-caravan',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'EXTR',
    title: 'EXTR',
    props: {
      subtitle: 'Extra men required',
      titleIcon: 'mdi-account-plus',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'LSC',
    title: 'LSC',
    props: {
      subtitle: 'Large Stair-climber',
      titleIcon: 'mdi-stairs',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'LATE',
    title: 'LATE',
    props: {
      subtitle: 'Late Booking',
      titleIcon: 'mdi-clock-alert',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'LIFT',
    title: 'LIFT',
    props: {
      subtitle: 'Lifting gear/rigger',
      titleIcon: 'mdi-forklift',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'LOW',
    title: 'LOW',
    props: {
      subtitle: 'Low Dock Height',
      titleIcon: 'mdi-format-align-bottom',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'ONE',
    title: 'ONE',
    props: {
      subtitle: 'One-man job',
      titleIcon: 'mdi-account',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'PPWK',
    title: 'PPWK',
    props: {
      subtitle: 'Paperwork required',
      titleIcon: 'mdi-file-document',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'PPE',
    title: 'PPE',
    props: {
      subtitle: 'Safety Equipment Required',
      titleIcon: 'mdi-face-mask',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'SSC',
    title: 'SSC',
    props: {
      subtitle: 'Small Stair-climber',
      titleIcon: 'mdi-stairs',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'TECH1',
    title: 'TECH1',
    props: {
      subtitle: 'Technicial lvl 1',
      titleIcon: 'mdi-progress-wrench',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'TECH2',
    title: 'TECH2',
    props: {
      subtitle: 'Technicial lvl 2',
      titleIcon: 'mdi-progress-wrench',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'TECH3',
    title: 'TECH3',
    props: {
      subtitle: 'Technicial lvl 3',
      titleIcon: 'mdi-progress-wrench',
    },
  },
  {
    // TODO
    // @ts-expect-error
    value: 'TECH',
    title: 'TECH',
    props: {
      subtitle: 'Technician required',
      titleIcon: 'mdi-wrench',
    },
  },
];

export const ticketsStatusNumValues: Record<TicketsStatusItemsValue, number> = {
  new: 1,
  open: 2,
  pending_reminder: 3,
  closed: 4,
  merged: 5,
  removed: 6,
  pending_close: 7,
  awaiting_dims: 8,
  awaiting_customer: 9,
} as const;

export const ticketsStatusItems: readonly TicketsStatusItems[] = [
  {
    title: 'New',
    value: 'new',
  },
  {
    title: 'Open',
    value: 'open',
  },
  {
    title: 'Pending reminder',
    value: 'pending_reminder',
  },
  {
    title: 'Closed',
    value: 'closed',
  },
  {
    title: 'Merged',
    value: 'merged',
  },
  {
    title: 'Removed',
    value: 'removed',
  },
  {
    title: 'Pending close',
    value: 'pending_close',
  },
  {
    title: 'Awaiting DIMS',
    value: 'awaiting_dims',
  },
  {
    title: 'Awaiting customer',
    value: 'awaiting_customer',
  },
];

export const managerFiltersItems = [
  {
    title: "Can't schedule",
    value: 'CNTSCHDL',
  },
  {
    title: 'Requested for change',
    value: 'RFC',
  },
  {
    title: 'Only Active',
    value: 'ACTIVE',
  },
  {
    title: 'Not Allocated',
    value: 'ALLOC',
  },
  {
    title: 'Picking issue',
    value: 'PICKINGISSUE',
  },
];

export const customerFiltersItems = [
  {
    title: 'Requested for change',
    value: 'RFC',
  },
  {
    title: 'Only Active',
    value: 'ACTIVE',
  },
  {
    title: 'Not Allocated',
    value: 'ALLOC',
  },
];

export const splitToBaseItems = [
  {
    title: 'SYDNEY',
    value: 'SYDNEY',
  },
  {
    title: 'BRISBANE',
    value: 'BRISBANE',
  },
  {
    title: 'MELBOURNE',
    value: 'MELBOURNE',
  },
  {
    title: 'ADELAIDE',
    value: 'ADELAIDE',
  },
  {
    title: 'PERTH',
    value: 'PERTH',
  },
  {
    title: 'CANBERRA',
    value: 'CANBERRA',
  },
  {
    title: 'DARWIN',
    value: 'DARWIN',
  },
];

// shortTitle is what the select renders once the option is picked; options
// without one fall back to the full title
const jobEditProductPrefixes = [
  { value: '-', title: '-' },
  { value: 'IN', title: 'IN' },
  { value: 'OUT', title: 'OUT' },
  { value: 'OUT: RECYCLE', title: 'OUT: RECYCLE', shortTitle: 'REC' },
  { value: 'OUT: STORE', title: 'OUT: STORE', shortTitle: 'STO' },
  { value: 'OUT: RETURN', title: 'OUT: RETURN', shortTitle: 'RTN' },
  { value: 'OUT: WORKSHOP', title: 'OUT: WORKSHOP', shortTitle: 'WS' },
];

export const jobEditProductPrefixItems = jobEditProductPrefixes.map(
  ({ value, title }) => ({ value, title }),
);

export const jobEditProductPrefixShortTitles: Record<
  string,
  string | undefined
> = Object.fromEntries(
  jobEditProductPrefixes.map(({ value, shortTitle }) => [value, shortTitle]),
);
